import _ from 'lodash'

export const getPostsByLanguage = (posts, lng) => {
  const postsFiltered = _.filter(posts, (post) => {
    if (!_.isEmpty(post) && post.node.locale) {
      const exists = new RegExp(`^${lng}`).test(post.node.locale.locale)
      return exists
    }
  })
  return postsFiltered
}
